export interface BrowserInfo {
  isWindows: boolean;
  isOldOutlook: boolean;
  isIE: boolean;
  isModernBrowser: boolean;
  safeEmailLimit: number;
}

export function detectBrowserEnvironment(): BrowserInfo {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();

  const isWindows = platform.includes("win") || userAgent.includes("windows");
  const isIE = userAgent.includes("msie") || userAgent.includes("trident");
  const isOldOutlook =
    userAgent.includes("outlook") && !userAgent.includes("2302");

  const isModernBrowser =
    userAgent.includes("chrome") ||
    userAgent.includes("firefox") ||
    userAgent.includes("safari") ||
    userAgent.includes("edge");

  let safeEmailLimit: number;

  if (isWindows || isIE || isOldOutlook) {
    safeEmailLimit = 1500;
  } else if (isModernBrowser && !isWindows) {
    safeEmailLimit = 100000;
  } else {
    safeEmailLimit = 1500;
  }

  return {
    isWindows,
    isOldOutlook,
    isIE,
    isModernBrowser,
    safeEmailLimit,
  };
}

export function getSafeEmailBodyLimit(): number {
  const browserInfo = detectBrowserEnvironment();
  return browserInfo.safeEmailLimit;
}
